import React from "react";
import "./styles.css";

function Suport() {
  function Open() {
    const newWindow = window.open(
      "https://api.whatsapp.com/send?phone=5585999370391"
    );
    if (newWindow) return false;
  }

  return (
    <>
      <div className="containerbox">
        <h1 className="textcenter">
          Clique aqui para falar com um de nossos atendentes pelo Whatsapp.
        </h1>
        <br></br>
        <button className="buttongreen" onClick={Open}>
          Falar com o atendente.
        </button>
      </div>
    </>
  );
}

export default Suport;
